import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem, GeocodedAddress } from '@/ui';
import type { GeoPoint } from '@/signalr';
import { reverseGeocode } from '@/features/shared/reverseGeocoding';

export type ApproximateAddressPanelItemProps = {
  coordinates: GeoPoint | null;
};

export function ApproximateAddressPanelItem({ coordinates }: ApproximateAddressPanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelInlineItem title={t('Incident_InfoPanel_ApproximateAddress')}>
      <GeocodedAddress geoPoint={coordinates} reverseGeocode={reverseGeocode} />
    </DataPanelInlineItem>
  );
}
